export default function Title({ children }) {
  return (
    <div className='font-bold md:text-[1.12rem] py-3'>
      { children}
    </div>
  )
}
